import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import Flexbox from "flexbox-react";
import ToastStore from "../../stores/ToastStore";
import { Drawer, NumericInput, Button, InputGroup, Icon, FormGroup, HTMLSelect } from "@blueprintjs/core";
import { FilledButton, OutlinedButton } from "../buttons-20250224T111359Z-001/buttons";
import axios from "axios";
import Cookies from "js-cookie";
const GoalEditDrawerForm = observer(({ isOpen, onClose, goalId ,isWeightAllow}) => {
  
  useEffect(() => {
    fetchQuestions();
  }, []);

  const fetchQuestions = () => {
    axios
      .get(`${Cookies.get("apiEnv")}/manager_assessments?goal_setting_id=${goalId}`)
      .then(response => {
        if (response.data.length > 0) {
          setQuestions(
            response.data.map(q => ({
              id: q.id,
              type: q.question_type,
              text: q.question,
              answerOptions: q.value,
              weight: q?.weightage
            }))
          );
        } else setQuestions([]);
      })
      .catch(() => {
        console.log("error fetching questions");
      });
  };

  const handleAddOptions = () => {
    const optionKey = `option${optionIndex}`;
    setAnswerOptions(prev => ({ ...prev, [optionKey]: "" }));
    setOptionIndex(prev => prev + 1);
  };

  const handleOptionChange = (key, value) => {
    setAnswerOptions({ ...answerOptions, [key]: value });
  };

  const handleSaveQuestion = () => {

    if (!questionText.trim()) {
      ToastStore.showToast("Question text is required!", "danger");
      return;
    }
  
    if (isWeightAllow && (questionWeightage === undefined || questionWeightage === 0 || questionWeightage === "")) {
      ToastStore.showToast("Weightage is required.!", "danger");
      return;
    }

    if (editingIndex !== null) {
      axios
        .put(`${Cookies.get("apiEnv")}/manager_assessments`, {
          goal_setting_id: goalId,
          manager_assessment_question_id: questionId,
          question: questionText,
          question_type: selectedType,
          value: answerOptions,
          ...(isWeightAllow && { weightage: questionWeightage })
         
          
        })
        .then(response => {
          fetchQuestions();
          setEditingIndex(null);
        });
    } else {
      axios
        .post(`${Cookies.get("apiEnv")}/manager_assessments/create_question`, {
          goal_setting_id: goalId,
          question: questionText,
          question_type: selectedType,
          value: answerOptions,
          ...(isWeightAllow && { weightage: questionWeightage })
        })
        .then(response => {
          fetchQuestions();
        });
    }
    resetForm();
    // catch (error) {
    //   console.error("Error saving question", error);
    // }
  };

  const handleEditQuestion = index => {
    const questionToEdit = questions[index];
    setSelectedType(questionToEdit.type);
    setQuestionText(questionToEdit.text);
    setAnswerOptions(questionToEdit.answerOptions);
    setEditingIndex(index);
    setQuestonId(questionToEdit.id);
    setQuestionWeightage(questionToEdit?.weight);
  };

  const handleDeleteQuestion = index => {
    axios
      .delete(`${Cookies.get("apiEnv")}/manager_assessments/${questions[index].id}`)
      .then(() => {
        fetchQuestions();
      })

      .catch(error => {
        console.error("Error deleting question", error);
      });
  };
  
  const defaultType = "Checkbox";
  const resetForm = () => {
    setSelectedType(defaultType);
    setQuestionText("");
    setAnswerOptions({});
    setQuestionWeightage('');
  };
  const totalWeight = questions.reduce((sum, q) => sum + (q.weight || 0), 0);
  const weightColor = totalWeight > 100 ? "red" : "green";

  return (
   
      <Flexbox flexDirection="row" flexGrow={1} padding="15px" style={{ overflowY: "auto" }}>

  <Flexbox flexDirection="row" flexGrow={1}>
     <Flexbox flexDirection="column" flexGrow={1} className="bp3-form-content">
       <input
         placeholder="Title"
         className="bp3-input bp3-control-no-margin push-10-b"
         type="text"
        name="title"
        value={editedGoals[goal.id]?.title || ""}
         onChange={e => this.handleGoalInputChange(goal.id, "title", e.target.value)}
        style={{ border: "1px solid #e1e1e1", boxShadow: "none", height: "34px" }}
        disabled={!selectedTimeframe.is_editable}
       />
       <TextArea
         name="description"
        placeholder="Description"
        rows={4}
        value={editedGoals[goal.id]?.description || ""}
        onChange={e => this.handleGoalInputChange(goal.id, "description", e.target.value)}
        className="push-10-t push-10-b"
        style={{ resize: "none", border: "1px solid #e1e1e1", boxShadow: "none" }}
        disabled={!selectedTimeframe.is_editable}
        />
        <div style={{ marginTop: "10px" }}>
          <FilledButton text={"Save"} onClick={() => this.handleSubmit(goal.id)} />
          <TextButton text={"Cancel"} onClick={() => this.handleCancelGoal(goal.id)} />
        </div>
        </Flexbox>
        <Flexbox flexDirection="column" flexGrow={1} margin="0px 10px" className="bp3-form-content">
          <Flexbox flexDirection="column" justifyContent="flex-end">
            <NumericInput
              allowNumericCharactersOnly={true}
              name="goal_weight"
              placeholder="Weight"
              min={0}
              max={100}
              value={editedGoals[goal.id]?.goal_weight}
              onValueChange={value => this.handleGoalInputChange(goal.id, "goal_weight", value)}
              buttonPosition="none"
              disabled={!selectedTimeframe.is_editable}
              style={{ height: "34px", width: "100px" }}
            />
          </Flexbox>
        
          <Flexbox className="push-10-t push-10-l" flexGrow={1} flexDirection="column" alignItems="center">
            <Slider
              labelStepSize={10}
              name="progress"
              min={0}
              max={100}
              value={editedGoals[goal.id]?.progress || 0}
              style={{ backgroundColor: "red" }}
              onChange={value =>
                this.setState(prevState => ({
                  editedGoals: {
                    ...prevState.editedGoals,
                    [goal.id]: {
                      ...prevState.editedGoals[goal.id],
                      progress: value
                    }
                  }
                }))
              }
            />
          </Flexbox>
        </Flexbox>
        
   </Flexbox>


      </Flexbox>
  );
});

export default GoalEditDrawerForm;
